<template>
  <div class="newsletter">
    <!-- Image by https://unsplash.com/@garciasaldana_ -->
    <div class="newsletter_background" style="background-image: url(/images/newsletter.jpg)"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div class="newsletter_content">
            <div class="newsletter_title text-center">Subskrybuj aby być na bieżąco</div>
            <div class="newsletter_form_container">
              <form v-show="!success" id="newsletter_form" class="newsletter_form" @submit.prevent>
                <div
                  class="d-flex flex-md-row flex-column align-content-center justify-content-between"
                >
                  <input
                    id="newsletter_input"
                    v-model="email"
                    type="email"
                    class="newsletter_input"
                    placeholder="Twój adres email"
                  />
                  <m-button
                    id="newsletter_button"
                    type="submit"
                    class="newsletter_button"
                    :loading="sendingData"
                    @click="send"
                  >
                    Subskrybuj
                  </m-button>
                </div>
              </form>
              <div v-show="success" class="newsletter_title text-center">
                Subskrybcja wykonana pomyślnie, dziękujemy :).
              </div>
              <div v-if="loggedUser" class="text-center manage" data-cy="manage-subscriptions">
                <router-link :to="{ name: 'subscriptions' }"> Zarządzaj subskrypcjami </router-link>
                <br />
                <router-link :to="{ name: 'customers' }"> Zarządzaj klientami </router-link>
              </div>
              <div v-show="error" class="text-white text-center" data-cy="subscription-error">
                Wystąpił błąd, spróbuj jeszcze raz.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import cli from '@/http.js'

export default {
  name: 'Subscribe',
  data() {
    return {
      email: '',
      sendingData: false,
      success: false,
      error: false,
    }
  },
  computed: {
    ...mapState(['loggedUser']),
  },
  methods: {
    async send() {
      this.error = false
      this.sendingData = true
      try {
        await cli.post('/subscriptions/', { email: this.email })
        this.success = true
      } catch {
        this.error = true
      } finally {
        this.sendingData = false
      }
    },
  },
}
</script>

<style scoped>
.newsletter_button {
  background: #ef7e1a;
}
.text-white {
  color: white;
}
.manage {
  margin-top: 20px;
}
</style>
